
























































































































































import {
  GLAccount,
  IDepartment,
  IGLAccount,
  IRequisitionLine,
  IRequisitionLineFieldError,
  RequisitionLineFieldError
} from '@/models';
import { defaultFilter, getObjectValueByPath } from '@/utils/helpers';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'RequisitionDetailFormLineCard',

  props: {
    lineNum: {
      type: Number,
      required: true
    },

    line: {
      type: Object as () => IRequisitionLine,
      required: true
    },

    departments: {
      type: Array as () => IDepartment[],
      required: true
    },

    accounts: {
      type: Array as () => IGLAccount[],
      required: true
    },

    fieldError: {
      type: Object as () => IRequisitionLineFieldError,
      default: () => new RequisitionLineFieldError()
    }
  },

  data: () => ({
    uom_list: [
      { uom: 'BAG', description: 'Bag' },
      { uom: 'BX', description: 'Box' },
      { uom: 'CA', description: 'Case' },
      { uom: 'CMT', description: 'Hundred Meters' },
      { uom: 'COL', description: 'Coil' },
      { uom: 'CTN', description: 'Carton' },
      { uom: 'EA', description: 'Each' },
      { uom: 'FT', description: 'Foot' },
      { uom: 'FT2', description: 'Square Feet' },
      { uom: 'GA', description: 'Gallons' },
      { uom: 'IN', description: 'Inch' },
      { uom: 'KG', description: 'Kilogram' },
      { uom: 'LB', description: 'Pound' },
      { uom: 'LOT', description: 'Lot' },
      { uom: 'M', description: 'Meter' },
      { uom: 'M2', description: 'Square Meter' },
      { uom: 'MM', description: 'Millimeter' },
      { uom: 'OZ', description: 'Ounces' },
      { uom: 'PKG', description: 'Package' },
      { uom: 'REL', description: 'Reel' },
      { uom: 'RL1', description: 'Roll' },
      { uom: 'ROL', description: 'Rolls' },
      { uom: 'SH', description: 'Sheet' },
      { uom: 'WKS', description: 'Weeks' }
    ],
    rules: [(v: string) => v.length <= 2000 || 'Max 2000 characters'],
  }),

  computed: {
    ...mapGetters({
      getGLAccountsByDepartment: 'accounting/getGLAccountsByDepartment'
    }),

    filteredAccounts(): GLAccount[] {
      if (this.line.department) {
        const department =
          typeof this.line.department === 'number'
            ? this.line.department
            : this.line.department.id;
        return this.getGLAccountsByDepartment(department);
      }

      return this.accounts;
    },

    lineTotal(): number {
      return this.$options.filters!.currency(
        this.line.quantity * this.line.unit_price
      );
    }
  },

  methods: {
    deleteLine() {
      this.$emit('delete:line', this.lineNum);
    },

    clearAccountValidation() {
      this.clearErrors();
      this.fieldError.account?.splice(0, this.fieldError.account?.length);
    },

    clearAccountIfNotValid() {
      this.clearAccountValidation();

      if (!this.line.account) return;
      this.line.account = null;
    },

    filter: (item: any, queryText: string): boolean => {
      const filterList = ['code', 'name', 'code-name', 'codename', 'code_name'];
      // added proxy filter and value keys to filter by
      item['code-name'] = `${item.code} - ${item.name}`;
      item['codename'] = `${item.code}${item.name}`;
      item['code_name'] = `${item.code} ${item.name}`;
      return filterList.some(key =>
        defaultFilter(getObjectValueByPath(item, key), queryText, item)
      );
    },

    clearErrors() {
      this.fieldError.clearErrors();
      this.$emit('clearErrors');
    }
  }
});
